<template>
    <HeaderAdmin></HeaderAdmin>
    <main>
        <section class="admin__container">
            <SideBar></SideBar>
            <RightContentWrapper>
                    <template #title>Saved Products</template>
                    <template #desc>Here your saved products</template>
                    <template #content><ProductList :itemsPerRow="3" :products="wishListData" @updateWish="getWishlist"></ProductList></template>
            </RightContentWrapper>
        </section>

    </main>
</template>

<script>
import HeaderAdmin from '@/components/Header/HeaderAdmin.vue';
import SideBar from '@/components/UserGroups/Admins/SideBar.vue';
import RightContentWrapper from '@/components/UserGroups/Admins/RightContentWrapper.vue';
import ProductList from "@/components/Products/ProductList.vue";
import axios from "axios";
    export default {
        components: {
            HeaderAdmin,
            SideBar,
            RightContentWrapper,
            ProductList
        },
        data() {
            return {
                wishListData: [],
            }
        },
        methods: {
            async getWishlist() {
                try {
                    let fData = new FormData();
                    const response = await axios.post('/user/get/wishlist', fData);
                    this.wishListData = response.data.data;
                } catch (error) {
                    console.error('Error updating wishlist:', error);
                }
            },

        },
        mounted() {
            this.getWishlist();
        },
    }
</script>

<style scoped>

</style>